import { Badge, IconButton, Tooltip } from '@mui/material';
import PhotoIcon from '@mui/icons-material/Photo';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TrendyolOrder } from '../../../interfaces/Trendyol/TrendyolOrder';
import { TrendyolOrderStatus } from '../../../interfaces/Trendyol/TrendyolOrderStatus';
import { sharedColors } from '../../../utils/Style';
import { ShipmentImagesDialog } from '../../Order/CollectOrderPage/ShipmentImagesDialog';

interface TrendyolActionCellProps {
  order: TrendyolOrder;
}

export const TrendyolActionCell = (props: TrendyolActionCellProps) => {
  const navigate = useNavigate();

  const [showImageDialog, setShowImageDialog] = useState(false);

  if (props.order.status === TrendyolOrderStatus.CANCELLED) return null;

  return props.order.shipmentImages.length > 0 ? (
    <>
      <ShipmentImagesDialog
        images={props.order.shipmentImages.map((image) => ({
          id: 0,
          orderID: props.order.trendyolID,
          image,
          createdAt: new Date(),
        }))}
        open={showImageDialog}
        onClose={() => setShowImageDialog(false)}
      />

      <Tooltip title='Resimleri görüntüle'>
        <IconButton onClick={() => setShowImageDialog(true)} color='primary'>
          <Badge
            badgeContent={props.order.shipmentImages.length}
            sx={{
              '& .MuiBadge-badge': {
                color: sharedColors.white,
                backgroundColor: sharedColors.blue5,
              },
            }}
            overlap='circular'
            style={{ transform: 'translate(20px, -10px)' }}
          />

          <PhotoIcon />
        </IconButton>
      </Tooltip>
    </>
  ) : (
    <Tooltip title='Hazırla'>
      <IconButton
        color='primary'
        onClick={() =>
          navigate(`/sales/trendyol/${props.order.trendyolID}/collect`)
        }
      >
        <ShoppingBasketIcon />
      </IconButton>
    </Tooltip>
  );
};
